import React from "react";
import Layout from "../components/Layout.js";
import UserPeofile from "../components/UserProfile.js";

export default function Profile() {
  return (
    <Layout>
      <UserPeofile />
    </Layout>
  );
}
